module.exports = __webpack_public_path__ + "static/media/ct.60daa8d1.svg";